export const SIGNUP_AND_LOGIN_EVENT = 'Signup and Login MF';
export const EMPTY_LABEL = '';

export enum OverlayType {
    ShopToClubOverlay = 'ShopToClub Overlay',
    LoginOverlay = 'Login Overlay',
    SignupOverlay = 'Signup Overlay',
}

export enum OverlayActions {
    OverlayShown = 'Overlay shown',
    OverlayDismissed = 'Overlay dismissed',
    Registration = 'Registration',
    PrivacyPolicyShown = 'Privacy Policy overlay shown',
    PrivacyPolicyAcceptance = 'Acceptance of the Privacy Policy',
    FormInteraction = 'Form interaction',
    FormFieldChanged = 'Form field changed',
    FormFieldError = 'Form field error',
    FormLinkClicked = 'Form link clicked',
}

export enum OverlayDismissLabel {
    CloseButton = 'Close button lick',
    LoginLink = 'Login link click',
    RegisterLink = 'Register link click',
    Background = 'Background click',
}

export enum ShopToClubRegistrationResolutions {
    New = 'new registration',
    Login = 'login',
    WrongPassword = 'correct email but wrong password',
}

export enum OverlayShownLabel {
    Default = 'Default',
    BannerClick = 'S2C banner click',
    SecondPageLoad = '2nd page load',
}

export enum FormFieldTracking {
    EmailFormField = 'Email form field',
    PasswordFormField = 'Password form field',
    AGBFormField = 'Agb form field',
    NewsletterAcceptFormField = 'Newsletter accept form field',
    NewsletterNotAcceptFormField = 'Newsletter not accept form field',
}

export enum FormLinkTracking {
    TermsOfServiceLink = 'Terms of service link',
    PrivacyPolicyLink = 'Privacy policy link',
    ForgotPasswordLink = 'Forgot password link',
}

export enum FormInteractions {
    FormUnfolded = 'Form unfolded',
    PrivacyPolicyScrolled = 'Privacy policy scrolled',
    ContinueButtonClicked = 'Continue button clicked',
    SubmitButtonClicked = 'Submit button clicked',
    LegalTextExpanded = 'Legal text expanded',
}

export type PrivacyPolicyAcceptanceLabel = 'Accepted' | 'Not accepted';

export enum SubmitAndLoginActions {
    Login = 'Login',
    Register = 'Register',
}

export enum LoginType {
    ShopLogin = 'Shop Login Overlay',
    ShopPartialLogin = 'Shop Partial Login Overlay',
}
